import { render } from "./MyProjectsPanel.vue?vue&type=template&id=6e0d4e66&scoped=true&ts=true"
import script from "./MyProjectsPanel.vue?vue&type=script&lang=ts"
export * from "./MyProjectsPanel.vue?vue&type=script&lang=ts"

import "./MyProjectsPanel.vue?vue&type=style&index=0&id=6e0d4e66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0d4e66"]])

export default __exports__